import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IssueStore } from '..';
import { Issue, IssueCategoryEnum } from '@sleipai/sleip-models';
import * as fromIssueStore from '../reducers/issue-store.reducer';

export const selectIssueStoreState =
  createFeatureSelector<fromIssueStore.State>(
    fromIssueStore.issueStoreFeatureKey
  );

export const isLoaded = (state: IssueStore.State): boolean => state.loaded;
export const isLoading = (state: IssueStore.State): boolean => state.loading;

export const selectaAllIssues: (state: object) => Issue[] =
  fromIssueStore.adapter.getSelectors(selectIssueStoreState).selectAll;

export const selectSingleIssue = (id: string) =>
  createSelector(selectaAllIssues, (issues: Issue[]) => {
    if (issues) {
      return issues.find((issue) => issue.id === id);
    } else {
      return null;
    }
  });

export const selectMultipleIssues = (
  ids: string[],
  filterOutInternal = false
) =>
  createSelector(selectaAllIssues, (issues: Issue[]) => {
    if (issues) {
      if (filterOutInternal)
        issues = issues.filter(
          (issue) => issue.category != IssueCategoryEnum.INTERNAL
        );
      return issues.filter(({ id }) => ids.indexOf(id ?? '') != -1);
    } else {
      return null;
    }
  });
